<template>
    <div>
      <!--    搜索部分-->
      <el-form :inline="true" :model="enquiryForm" class="demo-form-inline " label-width="80px">
        <div class="formOne">
          <el-form-item label="用户账号">
            <el-input size="medium" clearable v-model="enquiryForm.user_account" placeholder="用户账号"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div style="margin-bottom: 10px">
        <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
        <el-button size="medium" style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
        <el-button size="medium" style="font-size: 12px;" @click="handleEditFrom(0);">添加</el-button>
      </div>
      <!--    表格部分-->
      <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'id', order: 'descending'}"
                v-loading="loading" border id="tableDataId" size="mini">
        <el-table-column header-align="center" align="center" prop="user_name" label="用户名称" sortable>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="user_account" label="用户账号">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="user_ident_text" label="用户身份">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="p_auth" label="睿收钱权限">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="auth_range" label="睿收钱范围">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="creator" label="添加人">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="create_time" label="添加时间">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="modifier" label="修改人">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="update_time" label="修改时间">
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="medium" type="danger" style="font-size: 12px;" @click="handleEditFrom(scope.row.id);" >
                编辑
            </el-button>
          </template>
        </el-table-column>  
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :page-sizes="[20,50,100,200,500,1000]" :page-size="enquiryForm.limit" :total="total"
      layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
      <!-- 表格结束 -->
       <!--表单-->
      <fromAuth 
      v-if="fromVisible" :fromVisible="fromVisible" 
      :auth_id="auth_id"
       @handleFromVisible="handleFromVisible"
       />
      <!--表单结束-->
    </div>
  </template>
  <script>
  import fromAuth from "./components/fromAuth"
  export default {
    name: "rolelist",
    components:{
      fromAuth
    },
    data() {
      return {
        // 主页面部分
        loading: true, //列表loadding
        total: 0, //总数
        tableData: [], //表格数据
        enquiryForm: { //检索条件
          user_account: "", //用户账号
          limit: 20,
          page: 1,
        },
        fromVisible:false, //是否显示表单 
        auth_id:0,
      }
    },
    created() {
      this.getData(this.enquiryForm);
    },
    methods: {
      // 主页面部分
      //搜索
      handleSearch(searchForm) {
        searchForm.page = 1;
        this.getData(searchForm);
      },
      //重置
      Reset(searchForm) {
          searchForm.role_name = "", //角色名称
          searchForm.limit = 20,
          searchForm.page = 1,
        this.getData(searchForm);
      },
      //分页
      handleCurrentChange(page) { //当前选中页
        this.enquiryForm.page = page;
        this.getData(this.enquiryForm);
      },
      handleSizeChange(limit) { //条数
        this.enquiryForm.limit = limit;
        this.enquiryForm.page = 1;
        this.getData(this.enquiryForm);
      },
      //获取数据
      getData(params) { //初始化数据
        this.loading = true;
        this.$api.post("/api/ProductAuth/getProductAuthPage?page=" + params.page, params, res => {
          if (res.status == 200) {
            let tableData = res.data;
            this.total = tableData.total; //总数
            this.tableData = tableData.data;
          } else {
            this.$message.error(res.msg);
          }
          //渲染结束后取消加载
          this.loading = false;
        })
      },
      //关闭/打开表单  
      handleFromVisible(fromVisible){
        if(fromVisible == false){
          this.getData(this.enquiryForm);
        }
        this.fromVisible = fromVisible;
      },
  
      //编辑打开表单 
      handleEditFrom(auth_id){
        this.auth_id = auth_id;
        this.handleFromVisible(true);
      
      }
  
    }
  }
  </script>
  <style scoped>
  /deep/ .el-form-item__content .el-input-group {
    vertical-align: middle !important;
  }
  .code {
    cursor: pointer;
  }
  .code:hover {
    color: #5111ee;
    text-decoration: underline;
  }
  /*::v-deep .is-leaf{*/
  /*  color: #000000;*/
  /*  font-weight: bold;*/
  /*  background-color: #e5e4e4;*/
  /*}*/
  
  </style>
  